/* eslint-disable */

import React from 'react';
import { createScope, map, transformProxies } from './helpers';
import CtaBoxView from './CtaBoxView';

const scripts = [
  {
    loading: fetch(
      'https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=60600a132dfa607773b6ae0c'
    ).then((body) => body.text()),
    isAsync: false,
  },
  {
    loading: fetch('js/webflow.js').then((body) => body.text()),
    isAsync: false,
  },
];

let Controller;

class IndexView extends React.Component {
  static get Controller() {
    if (Controller) return Controller;

    try {
      Controller = require('..controllers/IndexController');
      Controller = Controller.default || Controller;

      return Controller;
    } catch (e) {
      if (e.code == 'MODULE_NOT_FOUND') {
        Controller = IndexView;

        return Controller;
      }

      throw e;
    }
  }

  componentDidMount() {
    const htmlEl = document.querySelector('html');
    htmlEl.dataset['wfPage'] = '60600a142dfa606b2fb6ae0d';
    htmlEl.dataset['wfSite'] = '60600a132dfa607773b6ae0c';

    scripts.concat(null).reduce((active, next) =>
      Promise.resolve(active).then((active) => {
        const loading = active.loading.then((script) => {
       
            new Function(`
          with (this) {
            eval(arguments[0])
          }
        `).call(window, script);
   

          return next;
        });

        return active.isAsync ? next : loading;
      })
    );
  }

  render() {
    const proxies =
      IndexView.Controller !== IndexView
        ? transformProxies(this.props.children)
        : {};

    return (
      <span>
        <style
          dangerouslySetInnerHTML={{
            __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/ame-89b37f.webflow.css);
          html {overflow: auto!important;}
          body {font-size: unset!important;}



            .af-class-div-block-38 .af-class-app-icon {

              box-shadow: none!important;

            }



          @media screen and (max-width: 479px) {

            .af-class-guide-image {

              min-height: 26vh!important;

            }

          }


        `,
          }}
        />
        <span className='af-view'>
          <div className='af-class-body'>
            <div
              data-w-id='253b796e-20e0-ab17-a580-61ef6b33a192'
              style={{
                WebkitTransform:
                  'translate3d(0, -84px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
                MozTransform:
                  'translate3d(0, -84px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
                msTransform:
                  'translate3d(0, -84px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
                transform:
                  'translate3d(0, -84px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
              }}
              className='af-class-header-hidden'
            >
              <div className='af-class-container w-container'>
                <div className='af-class-header-popup'>
                  <CtaBoxView.Controller />
                </div>
              </div>
            </div>
            <div className='af-class-section'>
              <div className='af-class-container-3 w-container'>
                <div className='af-class-div-block-33'>
                  <img
                    src='images/Logo.svg'
                    loading='lazy'
                    alt
                    className='af-class-image-22'
                  />
                  <h1 className='af-class-heading'>Ame</h1>
                  <div className='af-class-text-block-4'>
                    Organize it all.😎
                  </div>
                </div>
                <div className='af-class-div-block-21 af-class-change'>
                  <img
                    src='images/Ame-Hero.png'
                    loading='lazy'
                    sizes='(max-width: 767px) 93vw, (max-width: 991px) 71vw, 80vw'
                    srcSet='images/Ame-Hero-p-500.png 500w, images/Ame-Hero-p-800.png 800w, images/Ame-Hero-p-1080.png 1080w, images/Ame-Hero.png 1712w'
                    alt
                    className='af-class-image-21'
                  />
                </div>
              </div>
            </div>
            <div className='af-class-section-2 af-class-desktop'>
              <div className='af-class-container-2 w-container'>
                <div className='af-class-div-block-3'>
                  <div className='af-class-div-block-4'>
                    <div>
                      <h2 className='af-class-heading-2'>
                        Simple.<span className='af-class-text-span-19'>😊</span>{' '}
                        Seamless.
                        <span className='af-class-text-span-18'>👍</span>
                      </h2>
                      <div className='af-class-text-block-11'>
                        ✔️ Little to no learning curve.
                      </div>
                      <div className='af-class-text-block-13'>
                        ✔️ Minimal interface.
                      </div>
                      <div className='af-class-text-block-12'>
                        ✔️ Quick management.
                      </div>
                    </div>
                    <div className='af-class-div-block-10'>
                      <div
                        id='w-node-cf75b6b1-c063-096b-e5b7-0f47e251326f-2fb6ae0d'
                        className='af-class-feature-box'
                      >
                        <img
                          src='images/palette_black_24dp.svg'
                          loading='lazy'
                          alt
                          className='af-class-image-15'
                        />
                        <h4 className='af-class-heading-3'>
                          Color themed organization
                        </h4>
                      </div>
                      <div className='af-class-feature-box'>
                        <img
                          src='images/low_priority_black_24dp.svg'
                          loading='lazy'
                          alt
                          className='af-class-image-16'
                        />
                        <h4 className='af-class-heading-3'>
                          Drag and drop sorting
                        </h4>
                      </div>
                      <div className='af-class-feature-box'>
                        <img
                          src='images/saved_search_black_24dp.svg'
                          loading='lazy'
                          alt
                          className='af-class-image-17'
                        />
                        <h4 className='af-class-heading-3'>Easy Search</h4>
                      </div>
                    </div>
                    <div
                      id='w-node-bd19a3e5-406f-0afb-e1bd-1e79484b34a6-2fb6ae0d'
                      data-w-id='bd19a3e5-406f-0afb-e1bd-1e79484b34a6'
                      style={{ opacity: 0 }}
                      className='af-class-div-block-27'
                    >
                      <div className='af-class-div-block-29'>
                        <h4 className='af-class-heading-3'>Compatible with</h4>
                        <div className='af-class-div-block-38'>
                          <div
                            id='w-node-_262ce1e0-88ab-753a-38fc-48cc8373df33-2fb6ae0d'
                            className='af-class-compatible-box'
                          >
                            <div className='af-class-browser-item af-class-top'>
                              <img
                                src='images/Chrome.svg'
                                loading='lazy'
                                alt
                                className='af-class-app-icon af-class-compatible'
                              />
                              <div className='af-class-text-block-5'>
                                Chrome
                              </div>
                            </div>
                          </div>
                          <div
                            id='w-node-_21d83d5e-aee9-688a-ac0c-460a021a14e5-2fb6ae0d'
                            className='af-class-div-block-42'
                          >
                            <div className='af-class-browser-item af-class-left-bottom'>
                              <img
                                src='images/Safari.svg'
                                loading='lazy'
                                alt
                                className='af-class-app-icon af-class-compatible'
                              />
                              <div className='af-class-text-block-5'>
                                Safari
                              </div>
                            </div>
                          </div>
                          <div
                            id='w-node-_4824a573-dad3-7152-5f50-c5f54fd33221-2fb6ae0d'
                            className='af-class-compatible-box'
                          >
                            <div className='af-class-browser-item af-class-left-bottom'>
                              <img
                                src='images/Firefox.svg'
                                loading='lazy'
                                alt
                                className='af-class-app-icon af-class-compatible'
                              />
                              <div className='af-class-text-block-5'>
                                Firefox
                              </div>
                            </div>
                          </div>
                          <div
                            id='w-node-_1de708c6-317a-ce17-3aca-028ca03fc57f-2fb6ae0d'
                            className='af-class-div-block-41'
                          >
                            <div className='af-class-browser-item af-class-bottom'>
                              <img
                                src='images/Microsoft-Edge.svg'
                                loading='lazy'
                                alt
                                className='af-class-app-icon af-class-compatible'
                              />
                              <div className='af-class-text-block-5'>
                                Microsoft Edge
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='af-class-div-block-44'>
                      <div
                        style={{ paddingTop: '56.17021276595745%' }}
                        className='w-embed-youtubevideo af-class-youtube'
                      >
                        <iframe
                          src='https://www.youtube.com/embed/bFnOQXrOh7I?rel=0&controls=1&autoplay=0&mute=0&start=0'
                          frameBorder={0}
                          style={{
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            width: '100%',
                            height: '100%',
                            pointerEvents: 'auto',
                          }}
                          allow='autoplay; encrypted-media'
                          allowFullScreen
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='af-class-section-2 af-class-mobile'>
              <div className='af-class-container-2 w-container'>
                <div className='af-class-div-block-3'>
                  <div className='af-class-div-block-4'>
                    <div>
                      <h2 className='af-class-heading-2'>
                        Simple.<span className='af-class-text-span-19'>😊</span>{' '}
                        Seamless.
                        <span className='af-class-text-span-18'>👍</span>
                      </h2>
                      <div className='af-class-text-block-11'>
                        ✔️ Little to no learning curve.
                      </div>
                      <div className='af-class-text-block-13'>
                        ✔️ Minimal interface.
                      </div>
                      <div className='af-class-text-block-12'>
                        ✔️ Quick management.
                      </div>
                    </div>
                    <div className='af-class-div-block-44'>
                      <div
                        style={{ paddingTop: '56.17021276595745%' }}
                        className='w-embed-youtubevideo af-class-youtube'
                      >
                        <iframe
                          src='https://www.youtube.com/embed/bFnOQXrOh7I?rel=0&controls=1&autoplay=0&mute=0&start=0'
                          frameBorder={0}
                          style={{
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            width: '100%',
                            height: '100%',
                            pointerEvents: 'auto',
                          }}
                          allow='autoplay; encrypted-media'
                          allowFullScreen
                        />
                      </div>
                    </div>
                    <div className='af-class-div-block-10'>
                      <div
                        id='w-node-a7d55ebd-b4e4-da95-94d2-ad17fd7a98ac-2fb6ae0d'
                        className='af-class-feature-box'
                      >
                        <img
                          src='images/palette_black_24dp.svg'
                          loading='lazy'
                          alt
                          className='af-class-image-15'
                        />
                        <h4 className='af-class-heading-3'>
                          Color themed organization
                        </h4>
                      </div>
                      <div
                        id='w-node-a7d55ebd-b4e4-da95-94d2-ad17fd7a98b0-2fb6ae0d'
                        className='af-class-feature-box'
                      >
                        <img
                          src='images/low_priority_black_24dp.svg'
                          loading='lazy'
                          alt
                          className='af-class-image-16'
                        />
                        <h4 className='af-class-heading-3'>
                          Drag and drop sorting
                        </h4>
                      </div>
                      <div className='af-class-feature-box'>
                        <img
                          src='images/saved_search_black_24dp.svg'
                          loading='lazy'
                          alt
                          className='af-class-image-17'
                        />
                        <h4 className='af-class-heading-3'>Easy Search</h4>
                      </div>
                    </div>
                    <div
                      id='w-node-a7d55ebd-b4e4-da95-94d2-ad17fd7a98b8-2fb6ae0d'
                      className='af-class-div-block-27'
                    >
                      <div className='af-class-div-block-29'>
                        <h4 className='af-class-heading-3'>Compatible with</h4>
                        <div className='af-class-div-block-38'>
                          <div
                            id='w-node-a7d55ebd-b4e4-da95-94d2-ad17fd7a98bd-2fb6ae0d'
                            className='af-class-compatible-box'
                          >
                            <div className='af-class-browser-item af-class-top'>
                              <img
                                src='images/Chrome.svg'
                                loading='lazy'
                                alt
                                className='af-class-app-icon af-class-compatible'
                              />
                              <div className='af-class-text-block-5'>
                                Chrome
                              </div>
                            </div>
                          </div>
                          <div
                            id='w-node-a7d55ebd-b4e4-da95-94d2-ad17fd7a98c2-2fb6ae0d'
                            className='af-class-div-block-42'
                          >
                            <div className='af-class-browser-item af-class-left-bottom'>
                              <img
                                src='images/Safari.svg'
                                loading='lazy'
                                alt
                                className='af-class-app-icon'
                              />
                              <div className='af-class-text-block-5'>
                                Safari
                              </div>
                            </div>
                          </div>
                          <div
                            id='w-node-a7d55ebd-b4e4-da95-94d2-ad17fd7a98c7-2fb6ae0d'
                            className='af-class-compatible-box'
                          >
                            <div className='af-class-browser-item af-class-left-bottom'>
                              <img
                                src='images/Firefox.svg'
                                loading='lazy'
                                alt
                                className='af-class-app-icon af-class-compatible'
                              />
                              <div className='af-class-text-block-5'>
                                Firefox
                              </div>
                            </div>
                          </div>
                          <div
                            id='w-node-a7d55ebd-b4e4-da95-94d2-ad17fd7a98cc-2fb6ae0d'
                            className='af-class-div-block-41'
                          >
                            <div className='af-class-browser-item af-class-bottom'>
                              <img
                                src='images/Microsoft-Edge.svg'
                                loading='lazy'
                                alt
                                className='af-class-app-icon af-class-compatible'
                              />
                              <div className='af-class-text-block-5'>
                                Microsoft Edge
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='af-class-section-3'>
              <div className='af-class-container-4 w-container'>
                <div className='af-class-section-block'>
                  <h1 className='af-class-heading-4'>
                    Responsive.<span className='af-class-text-span-17'>🖥️</span>{' '}
                    Installable.
                    <span className='af-class-text-span-16'>📲</span>
                  </h1>
                  <div>
                    <div className='af-class-text-block-14'>
                      You can use{' '}
                      <em className='af-class-italic-text-4'>Ame </em>as the
                      native app by installing through the install prompt. In{' '}
                      <em className='af-class-italic-text-5'>iOS</em>, you need
                      to use{' '}
                      <strong className='af-class-bold-text-15'>
                        Add to Home Screen
                      </strong>{' '}
                      <span className='af-class-text-span-10'></span> option
                      from <em className='af-class-italic-text-6'>Safari</em>.
                    </div>
                  </div>
                  <div
                    data-duration-in={300}
                    data-duration-out={100}
                    className='af-class-tabs w-tabs'
                  >
                    <div
                      data-w-id='5397071d-f890-2fa2-76ca-8723ef3d93d9'
                      style={{ opacity: 0 }}
                      className='af-class-tabs-menu w-tab-menu'
                    >
                      <a
                        data-w-tab='Tab 1'
                        className='af-class-guide-tab af-class-responsive w-inline-block w-tab-link w--current'
                      >
                        <img
                          src='images/laptop_mac_black_24dp.svg'
                          loading='lazy'
                          alt
                          className='af-class-image-18'
                        />
                      </a>
                      <a
                        data-w-tab='Tab 2'
                        className='af-class-guide-tab af-class-responsive w-inline-block w-tab-link'
                      >
                        <img
                          src='images/tablet_mac_black_24dp.svg'
                          loading='lazy'
                          alt
                          className='af-class-image-19'
                        />
                      </a>
                      <a
                        data-w-tab='Tab 4'
                        className='af-class-guide-tab af-class-responsive af-class-bottom w-inline-block w-tab-link'
                      >
                        <img
                          src='images/phone_iphone_black_24dp.svg'
                          loading='lazy'
                          alt
                          className='af-class-image-19'
                        />
                      </a>
                    </div>
                    <div className='af-class-tabs-content-2 w-tab-content'>
                      <div
                        data-w-tab='Tab 1'
                        className='af-class-tab-pane-tab-1 w-tab-pane w--tab-active'
                      >
                        <img
                          src='images/Laptop.png'
                          srcSet='images/Laptop-p-500.png 500w, images/Laptop-p-800.png 800w, images/Laptop-p-1080.png 1080w, images/Laptop-p-1600.png 1600w, images/Laptop-p-2000.png 2000w, images/Laptop-p-2600.png 2600w, images/Laptop-p-3200.png 3200w, images/Laptop.png 4928w'
                          sizes='(max-width: 479px) 87vw, (max-width: 767px) 90vw, (max-width: 991px) 79vw, 74vw'
                          alt
                          className='af-class-image-8'
                        />
                      </div>
                      <div
                        data-w-tab='Tab 2'
                        className='af-class-tab-pane-tab-2 w-tab-pane'
                      >
                        <img
                          src='images/Tablet.png'
                          srcSet='images/Tablet-p-500.png 500w, images/Tablet-p-800.png 800w, images/Tablet-p-1080.png 1080w, images/Tablet-p-1600.png 1600w, images/Tablet-p-2000.png 2000w, images/Tablet-p-2600.png 2600w, images/Tablet-p-3200.png 3200w, images/Tablet.png 5102w'
                          sizes='(max-width: 479px) 87vw, (max-width: 767px) 90vw, (max-width: 991px) 79vw, 74vw'
                          alt
                          className='af-class-image-10'
                        />
                      </div>
                      <div
                        data-w-tab='Tab 4'
                        className='af-class-tab-pane-tab-2 w-tab-pane'
                      >
                        <img
                          src='images/Phone.png'
                          srcSet='images/Phone-p-500.png 500w, images/Phone-p-800.png 800w, images/Phone-p-1080.png 1080w, images/Phone-p-1600.png 1600w, images/Phone-p-2000.png 2000w, images/Phone-p-2600.png 2600w, images/Phone-p-3200.png 3200w, images/Phone.png 5872w'
                          sizes='(max-width: 479px) 87vw, (max-width: 767px) 90vw, (max-width: 991px) 79vw, 74vw'
                          alt
                          className='af-class-image-10'
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='af-class-section-5'>
              <div className='af-class-container-5 w-container'>
                <div id='Quick-guide-section'>
                  <h1 className='af-class-heading-5'>
                    Quick Guide.
                    <span className='af-class-text-span-15'>📜</span>
                  </h1>
                  <div
                    data-duration-in={300}
                    data-duration-out={100}
                    className='af-class-tabs-2 w-tabs'
                  >
                    <div
                      data-w-id='3733d6b9-517f-7c9d-6358-bdaa94a73f52'
                      style={{ opacity: 0 }}
                      className='af-class-tabs-menu-2 w-tab-menu'
                    >
                      <a
                        data-w-tab='Tab 1'
                        id='w-node-_3733d6b9-517f-7c9d-6358-bdaa94a73f53-2fb6ae0d'
                        className='af-class-guide-tab w-inline-block w-tab-link w--current'
                      >
                        <div className='af-class-text-block-15'>Add List</div>
                      </a>
                      <a
                        data-w-tab='Tab 2'
                        className='af-class-guide-tab w-inline-block w-tab-link'
                      >
                        <div className='af-class-text-block-16'>Add Task</div>
                      </a>
                      <a
                        data-w-tab='Tab 3'
                        className='af-class-guide-tab w-inline-block w-tab-link'
                      >
                        <div className='af-class-text-block-17'>Sort</div>
                      </a>
                      <a
                        data-w-tab='Tab 4'
                        className='af-class-guide-tab w-inline-block w-tab-link'
                      >
                        <div className='af-class-text-block-18'>
                          Delete/Edit
                        </div>
                      </a>
                      <a
                        data-w-tab='Tab 5'
                        className='af-class-guide-tab af-class-right w-inline-block w-tab-link'
                      >
                        <div className='af-class-text-block-19'>Search</div>
                      </a>
                    </div>
                    <div className='af-class-tabs-content w-tab-content'>
                      <div
                        data-w-tab='Tab 1'
                        data-w-id='3733d6b9-517f-7c9d-6358-bdaa94a73f5d'
                        style={{ opacity: 0 }}
                        className='af-class-guide-box w-tab-pane w--tab-active'
                      >
                        <div className='af-class-div-block-17'>
                          <img
                            src='images/Add-List.png'
                            srcSet='images/Add-List-p-500.png 500w, images/Add-List-p-800.png 800w, images/Add-List.png 1104w'
                            sizes='(max-width: 479px) 104.9375px, (max-width: 767px) 22vw, (max-width: 991px) 15vw, 13vw'
                            alt
                            className='af-class-guide-image'
                          />
                          <div className='af-class-guide-textbox'>
                            <strong className='af-class-guide-header'>
                              Add New List
                              <br />‍
                            </strong>
                            <br />
                            1. Click{' '}
                            <strong>
                              <em className='af-class-italic-text-3'>
                                Add List
                              </em>
                            </strong>
                            , then enter text.
                            <br />‍<br />
                            2. Choose{' '}
                            <strong className='af-class-bold-text-10'>
                              color{' '}
                            </strong>
                            to represent the theme of the list.
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-tab='Tab 2'
                        className='af-class-guide-box w-tab-pane'
                      >
                        <div className='af-class-div-block-17'>
                          <img
                            src='images/Add-Task.png'
                            loading='lazy'
                            sizes='(max-width: 479px) 106.234375px, (max-width: 767px) 22vw, (max-width: 991px) 15vw, 13vw'
                            srcSet='images/Add-Task-p-500.png 500w, images/Add-Task-p-800.png 800w, images/Add-Task.png 1104w'
                            alt
                            className='af-class-guide-image'
                          />
                          <div className='af-class-guide-textbox'>
                            <strong className='af-class-guide-header'>
                              Add New Task
                              <br />‍<br />
                            </strong>
                            1. Click{' '}
                            <strong>
                              <em className='af-class-italic-text'>Add Task</em>
                            </strong>
                            , then enter text.
                            <br />‍<br />
                            2. <em>Add notes:</em> In the{' '}
                            <strong>
                              <em className='af-class-italic-text-2'>Note </em>
                            </strong>
                            field, enter more info about the reminder.
                            <br />‍<br />
                            3. <em>Set Date and Time:</em> Toggle the{' '}
                            <strong className='af-class-bold-text-8'>
                              switches{' '}
                            </strong>
                            <span className='af-class-text-span'></span> to set
                            date and time.
                            <br />‍<br />
                            4. <em>Set Priority: </em>Toggle the{' '}
                            <strong className='af-class-bold-text-9'>
                              switch{' '}
                            </strong>
                            <span className='af-class-text-span'>
                              <strong></strong>
                            </span>
                            <strong> </strong>to mark an important reminder.
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-tab='Tab 3'
                        className='af-class-guide-box w-tab-pane'
                      >
                        <div className='af-class-div-block-17'>
                          <img
                            src='images/Sort.png'
                            loading='lazy'
                            sizes='(max-width: 479px) 100.421875px, (max-width: 767px) 21vw, (max-width: 991px) 15vw, 13vw'
                            srcSet='images/Sort-p-500.png 500w, images/Sort-p-800.png 800w, images/Sort.png 1104w'
                            alt
                            className='af-class-guide-image'
                          />
                          <div className='af-class-guide-textbox'>
                            <strong className='af-class-guide-header'>
                              Sort
                              <br />
                              <br />‍
                            </strong>
                            Click and{' '}
                            <strong className='af-class-bold-text-6'>
                              hold{' '}
                            </strong>
                            a list/task you want to move, then{' '}
                            <strong className='af-class-bold-text-7'>
                              drag{' '}
                            </strong>
                            it to a new location.
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-tab='Tab 4'
                        className='af-class-guide-box w-tab-pane'
                      >
                        <div className='af-class-div-block-17'>
                          <img
                            src='images/DeleteEdit.png'
                            loading='lazy'
                            sizes='(max-width: 767px) 132.359375px, (max-width: 991px) 19vw, 15vw'
                            srcSet='images/DeleteEdit-p-500.png 500w, images/DeleteEdit-p-800.png 800w, images/DeleteEdit.png 1104w'
                            alt
                            className='af-class-guide-image'
                          />
                          <div className='af-class-guide-textbox'>
                            <strong className='af-class-guide-header'>
                              Delete/Edit
                              <br />
                              <br />‍
                            </strong>
                            Toggle the{' '}
                            <strong className='af-class-bold-text'>
                              switch{' '}
                            </strong>
                            <span className='af-class-text-span-3'>
                              <strong className='af-class-bold-text-11'>
                                
                              </strong>
                            </span>
                            <strong> </strong>on the list/task box, then click
                            the{' '}
                            <strong className='af-class-bold-text-2'>
                              delete{' '}
                            </strong>
                            <span className='af-class-text-span-5'></span>
                            <strong className='af-class-bold-text-3'>
                              /edit{' '}
                            </strong>
                            <span className='af-class-text-span-6'>
                              <strong className='af-class-bold-text-12'>
                                
                              </strong>
                            </span>
                            <strong> </strong>button. You can also reorder the
                            list/task holding the{' '}
                            <strong className='af-class-bold-text-4'>
                              grip{' '}
                            </strong>
                            <span className='af-class-text-span-4'>
                              <strong className='af-class-bold-text-13'>
                                
                              </strong>
                            </span>
                            <strong> </strong>.
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-tab='Tab 5'
                        className='af-class-guide-box w-tab-pane'
                      >
                        <div className='af-class-div-block-17'>
                          <img
                            src='images/Search.png'
                            loading='lazy'
                            sizes='(max-width: 479px) 98.40625px, (max-width: 767px) 21vw, (max-width: 991px) 15vw, 13vw'
                            srcSet='images/Search-p-500.png 500w, images/Search-p-800.png 800w, images/Search.png 1104w'
                            alt
                            className='af-class-guide-image'
                          />
                          <div className='af-class-guide-textbox'>
                            <strong className='af-class-guide-header'>
                              Search
                              <br />‍<br />
                            </strong>
                            1. Click the{' '}
                            <strong className='af-class-bold-text-5'>
                              search{' '}
                            </strong>
                            <span className='af-class-text-span-2'>
                              <strong className='af-class-bold-text-14'>
                                
                              </strong>
                            </span>
                            <strong> </strong>button, then enter text.
                            <br />‍
                            <strong>
                              <br />
                            </strong>
                            2. Click the result to view.
                            <strong>
                              <br />
                              <br />
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='af-class-container-6 w-container'>
                <div>
                  <h1 className='af-class-heading-6'>
                    Built with.<span className='af-class-text-span-14'>🛠️</span>
                  </h1>
                  <div
                    data-w-id='ac9c2d32-51c6-1ca9-9db2-aeb27169dbc1'
                    style={{ opacity: 0 }}
                    className='af-class-div-block-26'
                  >
                    <div
                      id='w-node-_98fae1f4-4c56-2310-ebf2-99e817749ca0-2fb6ae0d'
                      className='af-class-built-with'
                    >
                      <h1 className='af-class-heading-7'>
                        Design <span className='af-class-text-span-11'></span>
                      </h1>
                      <div className='af-class-apps'>
                        <img
                          src='images/Photoshop.svg'
                          loading='lazy'
                          alt
                          className='af-class-app-icon'
                        />
                        <div className='af-class-text-block-5'>Photoshop</div>
                      </div>
                      <div className='af-class-apps'>
                        <img
                          src='images/Figma.svg'
                          loading='lazy'
                          alt
                          className='af-class-app-icon'
                        />
                        <div className='af-class-text-block-5'>Figma</div>
                      </div>
                      <div className='af-class-apps af-class-bottom'>
                        <img
                          src='images/Webflow.svg'
                          loading='lazy'
                          alt
                          className='af-class-app-icon'
                        />
                        <div className='af-class-text-block-5'>Webflow</div>
                      </div>
                    </div>
                    <div
                      id='w-node-_4795ece0-1673-94c9-ee81-0ee09ab8b92a-2fb6ae0d'
                      className='af-class-built-with'
                    >
                      <h1 className='af-class-heading-8'>
                        Development{' '}
                        <span className='af-class-text-span-12'></span>
                      </h1>
                      <div className='af-class-div-block-14'>
                        <div className='af-class-app-box af-class-left'>
                          <div className='af-class-apps'>
                            <img
                              src='images/React.svg'
                              loading='lazy'
                              alt
                              className='af-class-app-icon'
                            />
                            <div className='af-class-text-block-5'>React</div>
                          </div>
                          <div className='af-class-apps'>
                            <img
                              src='images/Javascript.svg'
                              loading='lazy'
                              alt
                              className='af-class-app-icon'
                            />
                            <div className='af-class-text-block-5'>
                              Javascript
                            </div>
                          </div>
                          <div className='af-class-apps af-class-bottom'>
                            <img
                              src='images/Html.svg'
                              loading='lazy'
                              alt
                              className='af-class-app-icon'
                            />
                            <div className='af-class-text-block-5'>Html</div>
                          </div>
                        </div>
                        <div className='af-class-app-box af-class-right'>
                          <div className='af-class-apps'>
                            <img
                              src='images/Scss.svg'
                              loading='lazy'
                              alt
                              className='af-class-app-icon'
                            />
                            <div className='af-class-text-block-5'>Scss</div>
                          </div>
                          <div className='af-class-apps'>
                            <img
                              src='images/CSS.svg'
                              loading='lazy'
                              alt
                              className='af-class-app-icon'
                            />
                            <div className='af-class-text-block-5'>Css</div>
                          </div>
                          <div className='af-class-apps af-class-bottom'>
                            <img
                              src='images/Firebase.svg'
                              loading='lazy'
                              alt
                              className='af-class-app-icon'
                            />
                            <div className='af-class-text-block-5'>
                              Firebase
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <footer id='footer' className='af-class-footer'>
              <div className='af-class-container-7 w-container'>
                <div>
                  <h1 className='af-class-heading-9'>
                    Cons.<span className='af-class-text-span-13'>👿</span>
                  </h1>
                  <div
                    data-w-id='af9710c5-f582-75fc-40a1-9a2c6fe33311'
                    style={{ opacity: 0 }}
                    className='af-class-div-block-24'
                  >
                    <div className='af-class-cons'>
                      <img
                        src='images/extension_off_black_24dp.svg'
                        loading='lazy'
                        alt
                        className='af-class-image-12'
                      />
                      <h1 className='af-class-heading-10'>
                        No advanced features
                      </h1>
                      <div>
                        <p className='af-class-paragraph'>
                          Since Ame is a practice project and design-focused,
                          only basic features are provided.
                        </p>
                      </div>
                    </div>
                    <div className='af-class-cons'>
                      <img
                        src='images/vpn_lock_black_24dp.svg'
                        loading='lazy'
                        alt
                        className='af-class-image-13'
                      />
                      <h1 className='af-class-heading-11'>Restricted access</h1>
                      <div>
                        <p className='af-class-paragraph-2'>
                          Ame database is built using Firebase. If Firebase is
                          restricted in your area, you might not be able to
                          visit the Page.
                        </p>
                      </div>
                    </div>
                    <div className='af-class-cons'>
                      <img
                        src='images/not_accessible_black_24dp.svg'
                        loading='lazy'
                        alt
                        className='af-class-image-14'
                      />
                      <h1 className='af-class-heading-12'>
                        Lack of accessibility support
                      </h1>
                      <div>
                        <p className='af-class-paragraph-3'>
                          Accessibility features are not focused during
                          development due to time constraints.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='af-class-container-8 w-container'>
                <div className='af-class-footer-flex-container af-class-div-block-25'>
                  <div className='af-class-div-block-12'>
                    <img
                      src='images/Okkar-Kyaw.jpg'
                      loading='lazy'
                      alt
                      className='af-class-image-11'
                    />
                    <h1 className='af-class-heading-13'>Okkar Kyaw</h1>
                  </div>
                  <div className='af-class-div-block-11'>
                    <h2 className='af-class-footer-heading'>📬 Contact me</h2>
                    <ul role='list' className='af-class-list-2 w-list-unstyled'>
                      <li>
                        <div className='af-class-div-block-18'>
                          <div>
                            <span className='af-class-text-span-7'></span>
                          </div>
                          <a
                            href='mailto:imokkarkyaw999@gmail.com?subject=Contact%20Oak'
                            className='af-class-footer-link'
                          >
                            imokkarkyaw999@gmail.com
                          </a>
                        </div>
                      </li>
                      <li>
                        <div className='af-class-div-block-19'>
                          <div>
                            <span className='af-class-text-span-7'></span>
                          </div>
                          <a
                            href='mailto:2016-miit-cse-028@miit.edu.mm?subject=Contact%20Oak'
                            className='af-class-footer-link'
                          >
                            <span className='af-class-text-span-9'>
                              2016-miit-cse-028@miit.edu.mm
                            </span>
                          </a>
                        </div>
                      </li>
                      <li>
                        <div className='af-class-div-block-20'>
                          <div>
                            <span className='af-class-text-span-7'></span>
                          </div>
                          <a
                            href='tel:09957950208'
                            className='af-class-footer-link'
                          >
                            09957950208
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='af-class-text-block-9'>
                  Ame: Personal Practice Project &nbsp;🖥️
                </div>
              </div>
            </footer>
            {/* [if lte IE 9]><![endif] */}
          </div>
        </span>
      </span>
    );
  }
}

export default IndexView;

/* eslint-enable */
